module.exports = {
  "name": "posthtml",
  "version": "0.16.5",
  "description": "HTML/XML processor",
  "keywords": [
    "html",
    "xml",
    "postproccessor",
    "parser",
    "transform",
    "transformations",
    "manipulation",
    "preprocessor",
    "processor"
  ],
  "main": "lib",
  "types": "types/posthtml.d.ts",
  "files": [
    "types",
    "lib"
  ],
  "engines": {
    "node": ">=12.0.0"
  },
  "dependencies": {
    "posthtml-parser": "^0.10.0",
    "posthtml-render": "^3.0.0"
  },
  "devDependencies": {
    "@commitlint/cli": "^13.1.0",
    "@commitlint/config-angular": "^13.1.0",
    "c8": "^7.7.3",
    "chai": "^4.3.4",
    "chai-as-promised": "^7.1.1",
    "chai-subset": "^1.6.0",
    "conventional-changelog-cli": "^2.1.1",
    "husky": "^7.0.1",
    "jsdoc-to-markdown": "^7.0.1",
    "lint-staged": "^11.1.1",
    "mocha": "^9.0.3",
    "standard": "^16.0.2"
  },
  "scripts": {
    "version": "conventional-changelog -i changelog.md -s -r 0 && git add changelog.md",
    "test": "c8 mocha",
    "docs:api": "jsdoc2md lib/api.js > docs/api.md",
    "docs:core": "jsdoc2md lib/index.js > docs/core.md"
  },
  "author": "Ivan Voischev <voischev.ivan@ya.ru>",
  "contributors": [
    {
      "name": "Ivan Voischev",
      "email": "voischev.ivan@ya.ru"
    },
    {
      "name": "Ivan Demidov",
      "email": "scrum@list.ru"
    }
  ],
  "homepage": "https://posthtml.org",
  "repository": "https://github.com/posthtml/posthtml.git",
  "bugs": "https://github.com/posthtml/posthtml/issues",
  "license": "MIT"
}
;